var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cargo-advance-search approval-search",
      staticStyle: { width: "100%", "margin-top": "5px" }
    },
    [
      _c(
        "div",
        { staticClass: "section" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module":
                  _vm.searchItemConfigs[_vm.type][_vm.documentConfigId]
                    .configModule,
                "grid-config-module":
                  _vm.searchItemConfigs[_vm.type][_vm.documentConfigId]
                    .gridConfigModule,
                "custom-search-items": _vm.customSearchItems,
                "expand-adv": _vm.expandAdv,
                "custom-sim-query-placeholder":
                  _vm.$t("Clearing.QuickRetrieval") +
                  _vm.$t("CargoMsg.Cargo_ApprovalSerialNumber")
              },
              on: {
                perConfigChange: function(value) {
                  _vm.innerPerConfigName = value
                },
                refreshGrid: function() {
                  _vm.innerGridRefreshId += 1
                },
                advSearchItemCallBack: _vm.toQuery,
                simSearchItemCallBack: _vm.toQuerySimple
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-position": "left", "label-width": "85px" }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showBtn,
                              expression: "showBtn"
                            }
                          ],
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: { gutter: 10 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _vm.showBatchBtn
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.toBatchApproval }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_BatchApproval"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showBatchBtn
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: { click: _vm.toBatchReject }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_BatchReject")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showPrintBtn
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.toPrint }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Payment.print")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.viewSource === "handleAll" &&
                              (_vm.isAdmin ||
                                _vm.$checkPermission([
                                  "button_ApprovalChecklistModule_cancel"
                                ]))
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.toCancel }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_Cancel")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }